import React from 'react';

const BoxBookingContext = React.createContext();

export default BoxBookingContext;
